/* eslint-disable no-param-reassign */

import PropTypes from 'prop-types';
import React, {Fragment, PureComponent} from 'react';
import EventListener from 'react-event-listener';
import {Prompt} from 'react-router';

import {_} from '../utils/i18n';

const DefaultWarning = _('If you leave this page now your changes will not be saved. Do you want to continue anyway?');

window.LeaveWarning = null;

class LeaveWarning extends PureComponent {

    render() {
        const {children, message, onConfirm, when} = this.props;

        return (
            <Fragment>
                {when && <EventListener target="window" onBeforeUnload={this.beforeUnload} onUnload={onConfirm} />}
                {this.context.router && <Prompt when={when} message={message} />}
                {children}
            </Fragment>
        );
    }

    componentDidMount() {
        this.makeGlobal(false);
    }

    componentDidUpdate() {
        this.makeGlobal(false);
    }

    componentWillUnmount() {
        this.makeGlobal(true);
    }

    makeGlobal(remove) {
        const {when, message, onConfirm} = this.props;

        if (when && remove === false) {
            window.LeaveWarning = message;
            window.onLeaveConfirm = onConfirm;
        } else {
            window.LeaveWarning = null;
            window.onLeaveConfirm = null;
        }
    }

    beforeUnload = event => {
        event.returnValue = this.props.message;
    };

}

LeaveWarning.propTypes = {
    children: PropTypes.node,
    message: PropTypes.string,
    onConfirm: PropTypes.func,
    when: PropTypes.bool,
};

LeaveWarning.defaultProps = {
    children: null,
    onConfirm: () => {},
    message: DefaultWarning,
    when: true,
};

LeaveWarning.contextTypes = {
    router: PropTypes.object,
};

export default LeaveWarning;



// WEBPACK FOOTER //
// ./scripts/components/LeaveWarning.js